import { useCallback } from 'react'

import { startCase } from 'lodash'
import { DropdownMenuItem, Sheet, SheetBody, SheetContent, SheetHeader, Tabs, TabsContent, TabsList, TabsTrigger } from 'twyne-new.ui'

import { useCodeEditor } from '@/components/CodeEditor/context'
import { usePageVariables } from '@Components/hooks/usePageVariables'

import PageHelpers from './PageHelpers'
import PageVariables from './PageVariables'

export function PageVariablesMenuItem({ onSelect }) {
  return <DropdownMenuItem onSelect={onSelect}>
    Page Variables
  </DropdownMenuItem>
}

function PageVariablesModal({ tabs = [], open = false, onOpenChange }) {
  const { editorsRef, activeEditor } = useCodeEditor()
  const fields = usePageVariables(open)

  const close = useCallback(() => onOpenChange(false), [onOpenChange])

  const selected = activeEditor || Object.keys(editorsRef.current || {})[0] || null

  const insert = useCallback(value => {
    const editor = selected && editorsRef.current[selected]
    if (!editor) {
      return
    }

    const selection = editor.getSelection()
    if (selection) {
      editor.executeEdits('page-variables', [{ range: selection, text: value, forceMoveMarkers: true }])
    } else {
      editor.setValue(editor.getValue() + value)
    }

    close()
  }, [editorsRef, selected, close])

  const insertLabel = useCallback(token => selected ? `Insert ${token} into ${startCase(selected)}` : 'No editor available to paste into', [selected])

  const paste = { selected, insert, insertLabel }

  return <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent size='xl' side='center' id='sheet-content' onOpenAutoFocus={e => e.preventDefault()}>
      <SheetHeader>
        Help
      </SheetHeader>
      <SheetBody>
        <Tabs defaultValue='variables'>
          <TabsList>
            <TabsTrigger className='pt-0!' value='variables'>Page Variables</TabsTrigger>
            <TabsTrigger className='pt-0!' value='helpers'>Page Helpers</TabsTrigger>
            {tabs.map(({ value, label }) => <TabsTrigger className='pt-0!' key={value} value={value}>{label}</TabsTrigger>)}
          </TabsList>
          <TabsContent value='variables'>
            <PageVariables fields={fields} paste={paste} />
          </TabsContent>
          <TabsContent value='helpers'>
            <PageHelpers paste={paste} />
          </TabsContent>
          {tabs.map(({ value, content }) => <TabsContent key={value} value={value}>{content}</TabsContent>)}
        </Tabs>
      </SheetBody>
    </SheetContent>
  </Sheet>
}

export default PageVariablesModal
